import { render, staticRenderFns } from "./SpotForm.vue?vue&type=template&id=872e0520&"
import script from "./SpotForm.vue?vue&type=script&lang=js&"
export * from "./SpotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports